var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFilterIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.33301H4.66667M14 3.33301H7.33333M2 7.99967H10M14 7.99967H12.6667M2 12.6663H3.33333M14 12.6663H6",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00002 4.66667C6.7364 4.66667 7.33335 4.06971 7.33335 3.33333C7.33335 2.59695 6.7364 2 6.00002 2C5.26364 2 4.66669 2.59695 4.66669 3.33333C4.66669 4.06971 5.26364 4.66667 6.00002 4.66667Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 9.33366C12.0697 9.33366 12.6667 8.73671 12.6667 8.00033C12.6667 7.26395 12.0697 6.66699 11.3333 6.66699C10.597 6.66699 10 7.26395 10 8.00033C10 8.73671 10.597 9.33366 11.3333 9.33366Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66665 13.9997C5.40303 13.9997 5.99998 13.4027 5.99998 12.6663C5.99998 11.93 5.40303 11.333 4.66665 11.333C3.93027 11.333 3.33331 11.93 3.33331 12.6663C3.33331 13.4027 3.93027 13.9997 4.66665 13.9997Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter-icon.d39ff99f.svg";
export { ForwardRef as ReactComponent };